"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
//Estilo do componente PPTextField
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        label: {
            fontFamily: "Inter",
            fontSize: 12,
            minHeight: 18
        },
        tooltip: {
            display: 'flex',
            alignItems: 'flex-end',
            height: '100%',
        },
        help: {
            fontSize: 13,
            color: 'grey',
            fontFamily: "Inter"
        },
        root: {
            marginTop: 3,
            backgroundColor: 'white',
            width: '100%',
            fontFamily: "Inter",
            fontSize: 14,
            height: 40,
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
        _disabled: {
            marginTop: 3,
            backgroundColor: '#EBEBEB',
            fontSize: 14,
            height: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            }
        },
        _required: {
            marginTop: 3,
            backgroundColor: 'white',
            fontSize: 14,
            height: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #141B4D',
                    borderTop: '1px solid #141B4D',
                    borderRight: '1px solid #141B4D',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderLeftWidth: 3,
                borderBottom: 0,
                borderTop: 0,
                borderRight: 0,
                borderLeftColor: '#FFB800',
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #898DA6',
                    borderTop: '1px solid #898DA6',
                    borderRight: '1px solid #898DA6',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            }
        },
        _readOnly: {
            marginTop: 3,
            fontSize: 14,
            fontFamily: "Inter",
            height: 40,
            backgroundColor: '#EBEBEB',
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
        //Para campos multilinha: 
        multiline: {
            marginTop: 3,
            backgroundColor: 'white',
            width: '100%',
            fontFamily: "Inter",
            fontSize: 14,
            minHeight: 40,
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
        multiline_disabled: {
            marginTop: 3,
            backgroundColor: '#EBEBEB',
            fontSize: 14,
            minHeight: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: 4,
                },
            }
        },
        multiline_required: {
            marginTop: 3,
            backgroundColor: 'white',
            fontSize: 14,
            minHeight: 40,
            fontFamily: "Inter",
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #141B4D',
                    borderTop: '1px solid #141B4D',
                    borderRight: '1px solid #141B4D',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderLeftWidth: 3,
                borderBottom: 0,
                borderTop: 0,
                borderRight: 0,
                borderLeftColor: '#FFB800',
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    borderLeftWidth: 3,
                    borderBottom: '1px solid #898DA6',
                    borderTop: '1px solid #898DA6',
                    borderRight: '1px solid #898DA6',
                    borderLeftColor: '#FFB800',
                    borderRadius: 4,
                },
            }
        },
        multiline_readOnly: {
            marginTop: 3,
            fontSize: 14,
            fontFamily: "Inter",
            minHeight: 40,
            backgroundColor: '#EBEBEB',
            "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #141B4D",
                    borderRadius: 4,
                },
            },
            "& .MuiOutlinedInput-notchedOutline": {
                border: "none",
                borderRadius: 4,
            },
            "&:hover": {
                "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #898DA6",
                    borderRadius: 4,
                },
            }
        },
    });
});
